import { LogoutIcon } from '@/components/icons';
import { useNote } from '@/context/NoteProvider';
import { useSimpleAudio } from '@/context/SimpleAudioProvider';
import { clearHistorySelection } from '@/helpers/historySelection';
import { useAuth } from '@/hooks';
import { Box } from '@mui/material';
import * as Sentry from '@sentry/react';
import { logoutStyles } from './style';

export const Logout = () => {
  const authContext = useAuth();
  const { resetAll } = useNote();
  const { resetAudioState } = useSimpleAudio();

  const handleLogout = () => {
    Sentry.startSpan(
      {
        op: 'ui.action',
        name: 'Logout',
      },
      span => {
        try {
          // Clear all application state
          resetAll(); // Clear NoteProvider state
          resetAudioState(); // Clear SimpleAudioProvider state
          clearHistorySelection(); // Clear localStorage history items
          authContext.logoutUser(); // Clear auth token

          // Clear user context in Sentry
          Sentry.setUser(null);
          span.setAttribute('success', true);
        } catch (error) {
          span.setAttribute('success', false);
          Sentry.captureException(error, {
            level: 'error',
            tags: { operation: 'logout' },
          });
        }
      }
    );
  };

  return (
    <Box sx={logoutStyles.logoutButton} onClick={handleLogout}>
      <Box component="span" sx={logoutStyles.logoutText}>
        Logout
      </Box>
      <Box sx={logoutStyles.logoutIconContainer}>
        <LogoutIcon width={20} height={20} />
      </Box>
    </Box>
  );
};
